import React, { useState, createContext } from "react";

export const UIStateContext = createContext();

// playerTheme : dark, dynamic
export const UIStateProvider = (props) => {
  const [UIState, setUIState] = useState({
    playerTheme: "dynamic",
  });

  return (
    <UIStateContext.Provider value={[UIState, setUIState]}>
      {props.children}
    </UIStateContext.Provider>
  );
};
